import { TypeOf, yup } from '@guiker/yup-util'

export const stockOrderShareSchema = yup.object({
  quantity: yup.number().required().min(1),
  askedPrice: yup.number().required(),
})

export type StockOrderShareSchema = TypeOf<typeof stockOrderShareSchema>
